import { useState, useEffect } from 'react';
import { memo } from 'radash';
import { Link } from 'react-router-dom';
import { useUserMetrics, useUserActivity, useFinanceMetrics } from '../state';
import { Button } from '../components';
import { Modal } from '../components/modal';
import { Loading } from '../components/loading';
import { Finances } from '../components/metrics';
import { JobsList } from '../components/job';

const cellStyle = { fontSize: 12, padding: '2px 4px' };

const Retention = ({ users }) => {
  const [open, setOpen] = useState();
  const [cutoff, setCutoff] = useState(10);
  const [hover, setHover] = useState();

  useEffect(() => {
    setCutoff(open ? 40 : 10);
  }, [open]);

  if (!users?.metrics?.retention) {
    return <Loading />;
  }

  const modalFor = (el, username) => (
    <Modal title={username}>
      {el}
      <Activity users={users} username={username} />
    </Modal>
  );

  const rows = users.metrics.retention.map((it, idx) => {
    const user = users.metrics.users[it.apiKey];
    return (
      <tr key={idx}>
        <td style={cellStyle}>{user?.username}</td>
        <td style={cellStyle}>{it.apiKey}</td>
        <td style={cellStyle}>
          {user?.stripeCustomerId ? `${user.stripeCustomerId.substring(0, 8)}:${user.paymentMethodLast4}` : ''}
        </td>
        <td style={cellStyle}>{user?.email}</td>
        <td style={cellStyle}>{it.activeDays}</td>
        <td style={{ ...cellStyle }}>
          {modalFor(
            <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold' }}>[recent]</div>,
            user?.username,
          )}
        </td>
      </tr>
    );
  });

  const rows2 = [];
  const now = Date.now();
  const h24 = 24 * 60 * 60 * 1000;

  const activityKeys = Object.keys(users.metrics.activity).sort((a, b) => {
    const v = memo((x) => Object.keys(users.metrics.activity[x] || {}).length);
    const v2 = memo((x) =>
      Object.keys(users.metrics.activity[x] || {})
        .sort()
        .at(-1),
    );
    const v3 = memo((x) =>
      Object.keys(users.metrics.activity[x] || {}).reduce((acc, key) => acc + users.metrics.activity[x][key], 0),
    );

    if (v(b) != v(a)) {
      return v(b) - v(a);
    }
    if (v2(a) != v2(b)) {
      return v2(b).localeCompare(v2(a));
    }
    return v3(b) - v3(a);
  });
  for (const apiKey of activityKeys) {
    const user = users.metrics.users[apiKey];
    const activity = users.metrics.activity[apiKey];
    const row = [
      <td style={{ ...cellStyle, width: 120 }}>{user?.username && modalFor(user.username, user.username)}</td>,
      <td style={{ ...cellStyle, textAlign: 'center', width: 30, fontWeight: 'bold', borderRightx: '1px solid black' }}>
        {Object.keys(activity).length}
      </td>,
    ];

    const now = Date.now();
    const h24 = 24 * 60 * 60 * 1000;
    for (let i = 0; i < users.metrics.lookback; i++) {
      const day = new Date(now - i * h24);
      const key = day.toISOString().split('T')[0];
      const val = activity[key] || 0;
      row.push(
        <td style={{ ...cellStyle, textAlign: 'right', width: 30, background: val > 0 ? '#dcf5dc' : '' }}>{val}</td>,
      );
    }

    rows2.push(
      <tr
        style={{ ...(apiKey == hover ? { background: '#f3f3f3' } : {}) }}
        key={apiKey}
        onMouseEnter={() => setHover(apiKey)}
        onMouseLeave={() => setHover()}
      >
        {row}
      </tr>,
    );

    if (rows2.length > cutoff) {
      break;
    }
  }

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th style={cellStyle}>User</th>
            <th style={cellStyle}>API Key</th>
            <th style={cellStyle}>Customer</th>
            <th style={cellStyle}>Email</th>
            <th style={cellStyle}>Active&nbsp;Days</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>

      <br />

      <table style={{ tableLayout: 'fixed' }}>
        <tbody>{rows2}</tbody>
      </table>
      {!open && (
        <Button small gray trans onClick={() => setOpen(true)}>
          Show More
        </Button>
      )}
      {open && (
        <Button small gray trans onClick={() => setOpen(false)}>
          Show Less
        </Button>
      )}

      {/*
      <pre>
        {JSON.stringify(users.metrics.activity, null, 2)}
      </pre>
      */}
    </div>
  );
};

const Activity = ({ users, username }) => {
  const { loading, activity } = useUserActivity(username);

  if (loading) {
    return <Loading />;
  }

  const nodes = (activity?.recent || []).map((job) => (
    <div style={{ display: 'flex' }} key={job.jobId}>
      <div style={{ width: 100 }}>
        <Link to={`/${job.name == 'agent' ? 'agents' : 'jobs'}/${job.jobId}`}>{job.jobId}</Link>
      </div>
      <div style={{ width: 100 }}>{job.type}</div>
      <div
        style={{
          width: '100%',
          maxWidth: 500,
          overflow: 'hidden',
          overflowX: 'scroll',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        }}
      >
        {JSON.stringify(job.details?.data, null, 2)}
      </div>
    </div>
  ));

  return (
    <div>
      <div>{nodes}</div>
    </div>
  );
};

export default function MetricsDashboardPage() {
  const users = useUserMetrics();
  const finances = useFinanceMetrics();

  // if (users.loading || !users.metrics?.retention) {
  //   return <Loading />;
  // }
  // if (finances.loading) {
  //   return <Loading />;
  // }
  // return <Retention users={users} />;

  return (
    <div>
      <h1>Metrics</h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ width: '50%' }}>
          <h2>Retention</h2>
          <Retention users={users} />
        </div>

        <div style={{ width: '50%' }}>
          <h2>Financials</h2>
          <div style={{ fontSize: 12 }}>
            <Finances />
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20, width: '100%' }}>
          <div style={{ width: 'calc(50% - 10px)' }}>
            <h2>Recent Agents</h2>
            <div style={{ fontSize: 12 }}>
              <JobsList narrow limit={20} forApiKey="all" types={['agent']} />
            </div>
          </div>

          <div style={{ width: 'calc(50% - 10px)' }}>
            <h2>Recent Jobs</h2>
            <div style={{ fontSize: 12 }}>
              <JobsList narrow limit={20} forApiKey="all" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
